import { render, staticRenderFns } from "./ReportTableCard.vue?vue&type=template&id=1a45bf2f&"
import script from "./ReportTableCard.vue?vue&type=script&lang=ts&"
export * from "./ReportTableCard.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTableCard.vue?vue&type=style&index=0&id=1a45bf2f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardSubtitle,VDataTable,VSpacer,VToolbar,VTooltip})
